"use client";
import { DefaultCarPageComponentProps } from "@/app/interface/components";
import { getVehicleDiferentials } from "@/app/utils/vehiclesInfo";
import Image from "next/image";
import React, { useState } from "react";

const DifferentialsMobile = ({
  car,
  model,
  version,
}: DefaultCarPageComponentProps) => {
  const [active, setActive] = useState(0);
  const info = getVehicleDiferentials(
    car?.name?.toLocaleLowerCase()?.replaceAll(" ", "-")!,
    model?.name!,
    version?.name!
  );
  const differentialsData = [
    {
      iconSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/icon_design.svg",
      title: "Design",
      description: info?.design,
    },
    {
      iconSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/icon_tecnologia.svg",
      title: "Tecnologia",
      description: info?.tecnologia,
    },
    {
      iconSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/icon_performance.svg",
      title: "Performance",
      description: info?.performance,
    },
    {
      iconSrc:
        "https://sablobsitestoyotaprd.blob.core.windows.net/images/icon_seguranca.svg",
      title: "Segurança",
      description: info?.seguranca,
    },
  ];

  return (
    <section className="flex flex-col items-end w-full">
      <div className="flex items-center pt-8 bg-white w-full">
        <div className="flex relative flex-col overflow-x-hidden  items-center self-stretch bg-white w-full">
          <Image
            width={400}
            height={400}
            loading="lazy"
            src="https://sablobsitestoyotaprd.blob.core.windows.net/images/fita_diferenciais.svg"
            className="object-contain -mr-2 -mb-1 z-0 w-full aspect-[6.1] max-w-[320px] ml-auto"
            alt=""
          />
          <div className="flex z-0 gap-2.5 items-start w-full bg-zinc-900">
            <h2 className="absolute top-4 right-5 z-0 self-start text-xl leading-tight text-white h-[29px]  w-[133px]">
              Diferenciais
            </h2>
          </div>
        </div>
      </div>
      <div className="bg-zinc-900 py-3 w-full flex flex-col items-center">
        <div className="flex justify-around items-center w-full">
          {differentialsData.map((data, i) => {
            return (
              <Image
                key={data.iconSrc + i}
                width={400}
                height={400}
                alt="icon"
                onClick={() => setActive(i)}
                loading="lazy"
                src={data.iconSrc}
                className={`object-contain aspect-square w-[55px] mx-auto rounded transition-all ${
                  active == i ? "invert bg-black" : "invert-0 bg-transparent"
                }`}
              />
            );
          })}
        </div>
        <div className="grid grid-cols-4 items-center justify-center py-2 w-full transition-all">
          <div className="col-span-4 h-1 w-full border-b bordedr-white" />
          {active > 0 && <div />}
          {active > 1 && <div />}
          {active > 2 && <div />}
          <div className={` flex justify-center relative -mt-2 `}>
            <div className="w-3 h-3 rounded-full border-2 border-white border-solid bg-zinc-900 " />
          </div>
        </div>
        <div>
          <div className="flex flex-col mt-4 w-full px-4 min-h-72">
            <h3 className="text-lg font-semibold text-white">
              {differentialsData[active].title}
            </h3>
            <p className="mt-2 text-base leading-6 text-stone-50">
              {differentialsData[active].description}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DifferentialsMobile;
